module.exports = __webpack_public_path__ + "img/g.ccfdb7f6.jpg";